import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import jsPDF from "jspdf";

const AddEmployeeForms = ({ isOpen, onRequestClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    phone: "",
    address: "",
    gender: "",
  
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Employee Details", 20, 20);

    const lineHeight = 10;
    let y = 40;

    Object.entries(formData).forEach(([key, value]) => {
      const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
      doc.text(`${formattedKey}: ${value}`, 20, y);
      y += lineHeight;
    });

    return doc;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const doc = generatePDF();
    const pdfBlob = doc.output("blob"); // Get blob to pass
    onSave({
        blob: pdfBlob,
        name: (formData.name || "employeeForm") + ".pdf"
      });
      
    onRequestClose();
  };

  const inputStyle = {
    border: "none",
    borderBottom: "1px solid black",
    borderRadius: 0,
    outline: "none",
    width: "300px",
  };

  const labelStyle = {
    display: "inline-block",
    width: "120px",
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Employee Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {["name", "age", "phone", "address", "gender"].map((field) => (
            <div className="mb-3" key={field}>
              <label style={labelStyle}>
                {field.charAt(0).toUpperCase() + field.slice(1)}:
              </label>
              <input
                type={field === "age" ? "number" : "text"}
                name={field}
                value={formData[field]}
                style={inputStyle}
                onChange={handleChange}
                required={field === "name"}
              />
            </div>
          ))}

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onRequestClose} className="me-2">
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Save
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddEmployeeForms;
